<div animate.enter="animate-down"
  class="h-[calc(100vh-(6.5rem))] w-full flex flex-col p-4 xl:p-8 gap-4 relative">

  <app-top-banner [title]="('faqs' | translate)" [hideAdd]="true"
    [viewDetails]="false" [useDropdownOnCreate]="false" />

  <div class="flex flex-1 border border-border rounded-xl overflow-hidden min-h-0">
    <div class="w-[30%] flex flex-col border-r border-border bg-slate-50">
      <div class="px-5 py-4 border-b border-border">
        <span class="text-xs font-medium text-muted-foreground">Select FAQs by category.</span>
      </div>
      <div class="flex-1 overflow-y-auto divide-y divide-border">
        <!-- faqs with no categories wont be on the list -->
        <ng-container *ngIf="faqCategories?.length; else noCategories">
          <button
            *ngFor="let category of faqCategories; let i = index"
            type="button"
            class="w-full text-left px-5 py-4 transition-colors border-b border-border"
            [class.bg-primary-600]="selectedCategory === category"
            [class.text-white]="selectedCategory === category"
            [class.text-slate-700]="selectedCategory !== category"
            (click)="selectCategory(category)"
          >
            <span class="text-sm font-medium">
              {{ category.toLowerCase() | titlecase }}
            </span>
          </button>
        </ng-container>

        <ng-template #noCategories>
          <div class="px-5 py-6 text-sm text-slate-500">No categories available yet.</div>
        </ng-template>
      </div>
    </div>

    <div class="flex-1 flex flex-col min-w-0 bg-white">
      <div class="border-b border-border px-5 py-4 bg-slate-50">
        <span class="text-sm text-slate-500">{{ selectedCategory.toLowerCase() | titlecase }} FAQs</span>
      </div>
      <div class="flex-1 overflow-y-auto">
        <ng-container *ngIf="categoryFaqs?.length; else noFaqs">
          <div *ngFor="let faq of categoryFaqs; let i = index" class="border-b border-border last:border-b-0">
            <button
              type="button"
              class="w-full flex items-center justify-between px-6 py-4 text-left gap-4 hover:bg-slate-50 transition-colors"
              (click)="toggleQuestion(i)"
            >
              <span class="text-sm md:text-base font-medium text-slate-900">
                {{ faq.question }}
              </span>
              <span class="shrink-0 flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-transform duration-200"
                [class.rotate-180]="activeQuestionIndex === i"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </button>
            <div class="overflow-hidden transition-all duration-300 px-6"
              [style.maxHeight]="activeQuestionIndex === i ? '1000px' : '0px'"
              [class.pb-6]="activeQuestionIndex === i"
            >
              <p class="text-sm text-slate-600 leading-relaxed" *ngIf="activeQuestionIndex === i">
                {{ faq.answer }}
              </p>
            </div>
          </div>
        </ng-container>

        <ng-template #noFaqs>
          <div class="p-6 text-sm text-slate-500">No FAQs found for this category yet.</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
